import * as React from "react";
import { SVGProps } from "react";

const Skycoin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 714 537" {...props}>
    <path
      fill="#0072ff"
      d="M617.6 199.1 461.4 537H399l164.4-355.7c19.3 3.1 37.5 9.1 54.2 17.8M344.3.6 104 520.5C42.7 492.2 0 430.2 0 358c0-98.9 79.9-179 178.5-179C178.5 84.4 251.7 7.2 344.3.6M535.6 179 370.1 537h-67.6L510.3 87.5c16 26.8 25.3 58 25.3 91.5m61.5 346.9 106-229.2c7 19.2 11 39.8 11 61.4 0 77-48.7 142.6-117 167.8m46.8-310c14.8 11.4 27.9 24.9 38.5 40.4L553 536.1c-5.7.6-11.6.9-17.4.9h-40.1l148.4-321.1M357.7 0c25.3.1 49.3 5.5 71.1 15.2L187.6 537h-9.1c-22.4 0-43.8-4.3-63.5-11.9L357.7 0m138.5 66.9L278.9 537H206L443.8 22.6c20.2 11.3 38 26.4 52.4 44.3"
    />
  </svg>
);

export default Skycoin;
